import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'layout',
    component: () => import('@/layout/index.vue'),
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home.vue')
      },
      {
        name: "login",
        path: "login",
        component: () => import('@/views/login.vue'),
        meta: {
          noFooter: true
        }
      },
      {
        name: "register",
        path: "register",
        component: () => import('@/views/register.vue'),
        meta: {
          noFooter: true
        }
      },
    ]
  },
  {
    path: '/joinus',
    name: 'joinus',
    component: () => import('@/views/joinus.vue')
  },
  {
    path: '/biz',
    name: 'biz',
    component: () => import('@/views/biz.vue')
  },
  {
    path: '/kol-ytb/:index?',
    name: 'youtube',
    component: () => import('@/views/kol/_index.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
